import React from "react";

export const ApiArt = () => (
    <svg className="intro-art" viewBox="0 0 320 150" role="img" aria-label="Seu sistema conversando com a Brinde.me: pergunta e resposta">
        <rect x="6" y="40" width="104" height="70" rx="16" className="ia-node" />
        <text x="58" y="79" textAnchor="middle" className="ia-title">Seu sistema</text>
        <text x="58" y="93" textAnchor="middle" className="ia-sub">ERP · CRM</text>

        <rect x="210" y="40" width="104" height="70" rx="16" className="ia-node ia-node--brand" />
        <text x="262" y="79" textAnchor="middle" className="ia-title ia-title--brand">Brinde.me</text>
        <text x="262" y="93" textAnchor="middle" className="ia-sub">API</text>

        <text x="160" y="58" textAnchor="middle" className="ia-mini">pergunta</text>
        <line x1="118" y1="67" x2="200" y2="67" className="ia-line" />
        <polygon points="206,67 197,62.5 197,71.5" className="ia-arrow" />

        <line x1="120" y1="83" x2="202" y2="83" className="ia-line" />
        <polygon points="114,83 123,78.5 123,87.5" className="ia-arrow" />
        <text x="160" y="102" textAnchor="middle" className="ia-mini">resposta</text>

        <rect x="116" y="64" width="13" height="6" rx="3" className="ia-pkt ia-pkt--req" />
        <rect x="191" y="80" width="13" height="6" rx="3" className="ia-pkt ia-pkt--res" />
    </svg>
);

export const WebhookArt = () => (
    <svg className="intro-art" viewBox="0 0 320 150" role="img" aria-label="A Brinde.me envia uma notificação em tempo real para o seu sistema">
        <circle cx="58" cy="75" r="40" className="ia-pulse" />
        <circle cx="58" cy="75" r="40" className="ia-pulse ia-pulse--2" />

        <rect x="6" y="40" width="104" height="70" rx="16" className="ia-node ia-node--brand" />
        <text x="58" y="79" textAnchor="middle" className="ia-title ia-title--brand">Brinde.me</text>
        <text x="58" y="93" textAnchor="middle" className="ia-sub">API</text>

        <text x="160" y="62" textAnchor="middle" className="ia-mini">tempo real</text>
        <line x1="118" y1="75" x2="202" y2="75" className="ia-line" />
        <polygon points="208,75 199,70.5 199,79.5" className="ia-arrow" />

        <rect x="210" y="40" width="104" height="70" rx="16" className="ia-node" />
        <text x="262" y="79" textAnchor="middle" className="ia-title">Seu sistema</text>
        <text x="262" y="93" textAnchor="middle" className="ia-sub">ERP · CRM</text>

        <rect x="116" y="72" width="13" height="6" rx="3" className="ia-pkt ia-pkt--push" />
    </svg>
);

export default { ApiArt, WebhookArt };
